import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {Property} from "../../../model/property";
import {OrderService} from "../../../service/order.service";
import {DocumentService} from "../../../service/document.service";
import {ActivatedRoute, Router} from "@angular/router";
import {Document} from "../../../model/document";
import {DocumentPrice} from "../../../model/documentPrice";
import {AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {UserServiceService} from "../../../service/user-service.service";
import {User} from "../../../model/user";
import {Order} from "../../../model/order";
import {AuthorityService} from "../../../service/authority.service";
import {MatDialog} from "@angular/material/dialog";
import {NotificationSettings} from "../../../model/notificationSettings";
import {Cart} from "../../../model/cart";
import {Product} from "../../../model/product";
import {ProductService} from "../../../service/product.service";
import {PlatformService} from "../../../service/platform.service";
import {PricingPackage} from "../../../model/pricingPackage";
import NameFinderUtils from "../../../utils/name-finder-utils";
import {BookableServiceService} from "../../../service/bookable-service.service";
import {BookableService} from "../../../model/bookableService";
import { LoginIdService } from "../../../service/login-id.service";
import { PlatformProfile } from "../../../model/platformprofile";
import { BillingAdress } from "../../../model/billingAdress";
import { BillingAddressDialogComponent } from "../../dialogs/billing-address-dialog/billing-address-dialog.component";
import FormUtils from "../../../utils/form-utils";
import {NgxIndexedDBService} from "ngx-indexed-db";
import {BillingPositionBody} from "../../../model/billing-position-body";
import StaticData from "../../../utils/static-data";
import {ProductValueFormComponent} from "../products-container/product-value-form/product-value-form.component";
import {ProductValue} from "../../../model/productValue";
import ProductUtils from "../../../utils/product-utils";
import {SnackbarService} from "../../../service/snackbar.service";
import {forkJoin} from "rxjs";
import {PricingUtils} from "../../../utils/pricing-utils";
import {PlatformUtils} from "../../../utils/platform-utils";
import {Pricing} from "../../../model/platform/pricing";
import PackageSelectionUtils from "../../../utils/package-selection-utils";

@Component({
  selector: 'app-summary-page',
  templateUrl: './summary-page.component.html',
  styleUrls: ['./summary-page.component.css']
})
export class SummaryPageComponent implements OnInit {

  properties: Array<Property> = [];
  acceptingAGB: boolean = false;
  documentPrices: Array<DocumentPrice>;
  documents: Array<Document>;
  products: Array<Product>;
  bookableServicesByCategory: Map<string, BookableService[]> = new Map<string, BookableService[]>();
  productsByCategory: Map<string, Product[]>;
  bauakProducts: Product[] = [];
  paymentDetailsProperties;
  paymentDetailsDataResearch;
  paymentDetailsExplicitDocumentPackages;
  contactListForm: UntypedFormGroup;
  additionalOrderInformationForm: UntypedFormGroup;
  propertySum = 0;
  discount = 0;
  pricingUnavailable = false;
  maxInformationInput = 2000;
  maxReferenceInput = 255;
  propertySumWithoutDataSearch;
  propertySumDataSearch;
  startedOrderProcess = false;
  showOrderError: boolean = false;
  contactList = Array<string>();
  errorMsg = "";
  currentMultiUser: User;
  user: User;
  platformProfile: PlatformProfile;
  categorizedDocumentsList: { [propertyId: number]: { packageGroups: { package: PricingPackage, documents: Document[] }[], regularPricingDocs: Document[], pricingOnRequestDocs: Document[], premiumServiceDocs: Document[] } } = {};
  bookedAdditionalBauaktenServices: string[] = [];
  premiumServiceDocumentOrderLines: any;
  cancellationsByProperty: { [propertyId: string]: Cancellation[] } = {};
  initComplete: boolean = false;
  pricing: Pricing;
  bauakPricePerHour: number;
  bewilCertificatePrice: number;
  premiumServiceDocumentGroups: Map<string,DocumentCategoryGroup[]> = new Map<string, DocumentCategoryGroup[]>();
  getServiceLongName = NameFinderUtils.getServiceLongName;
  findProductCategoryByShortName = NameFinderUtils.findProductCategoryByShortName;

  @ViewChild('callBillingFormDialog') callBillingFormDialog: TemplateRef<any>;
  constructor(private readonly orderService: OrderService, private readonly documentService: DocumentService,
              private readonly authorityService: AuthorityService, private readonly userService: UserServiceService,
              private readonly router: Router, private readonly formBuilder: UntypedFormBuilder, private readonly dialog: MatDialog,
              private readonly productService: ProductService,private readonly platformService: PlatformService,
              private readonly loginIdService: LoginIdService, private readonly bookableServiceService: BookableServiceService,
              private readonly route: ActivatedRoute, private readonly indexDBService: NgxIndexedDBService,
              private readonly snackbarService: SnackbarService) {}


  async ngOnInit(): Promise<any> {

    this.pricing = PlatformUtils.getPlatformPricing();
    this.bauakPricePerHour = PricingUtils.getBauakPricePerHour();
    this.bewilCertificatePrice = PricingUtils.getBewilCertificatePrice();
    this.initContactListForm();
    this.initAdditionalOrderInformationForm();

    // wait until the loginIdService has been initialized
    await this.loginIdService.loginServiceInitialized$.toPromise();

    let retrievedObject;

    // checks if owner-research=true is in the URL and then loads the correct property
    this.route.queryParams.subscribe(params => {
      if (params['owner-research'] === 'true') {
        retrievedObject = sessionStorage.getItem('new_order_owner_research_properties');
      } else {
        retrievedObject = sessionStorage.getItem('new_order_properties');
      }
    });

    let retrievedLegitimateInterest =  sessionStorage.getItem('legitimate_interest');
    if(!!retrievedLegitimateInterest && retrievedLegitimateInterest !== ''){
      this.additionalOrderInformationForm.controls["additionalInformation"].setValue(JSON.parse(retrievedLegitimateInterest));
    }

    if (retrievedObject != null) {
      this.properties = JSON.parse(retrievedObject);
    }
    if (this.properties.length < 1) {
      this.router.navigateByUrl("/new_order")
    }
    this.setCustomOrderName();
    let products = sessionStorage.getItem('products');
    if(products) {
      this.products = JSON.parse(products);
    } else {
      this.productService.getProducts().subscribe();
    }

    this.productService.getProductByCategory().subscribe(productsByCategory => {
      this.productsByCategory = productsByCategory;
      this.initBauakProducts();
    });

    this.bookableServiceService.getBookableServicesByCategoryFromStorageOrApi().subscribe(bookableServicesByCategory => {
      this.bookableServicesByCategory = new Map<string, BookableService[]>(Object.entries(bookableServicesByCategory));

    });

    this.properties.forEach(p => {
      if (p.contactMail && !this.contactList.find(c => c === p.contactMail)) {
        this.contactList.push(p.contactMail);
      }

      /*Get all booked additional bauakten services across all properties to determine which pricing information has to be shown*/
      if (this.hasAnyPropertyBauakte()) {
        p.documents.forEach(document => {
          document.selectedServices.forEach(service => {
            if (!this.bookedAdditionalBauaktenServices.includes(service.nameShort) &&
                NameFinderUtils.findBookableServiceCategoryByShortName(service.nameShort, this.bookableServicesByCategory) === "ABServices") {
              this.bookedAdditionalBauaktenServices.push(service.nameShort)
            }
          })
        });
      }
    });

    this.addCurrentUserMailToContactList();
    this.currentMultiUser = JSON.parse(sessionStorage.getItem('currentMultiUser'));
    this.user = JSON.parse(sessionStorage.getItem('user'));

    if(!this.currentMultiUser){
        this.userService.getUserById(this.loginIdService.getCurrentLoginId()).subscribe(res => {
            this.currentMultiUser = res;
        });
    }

    this.platformProfile = JSON.parse(sessionStorage.getItem("platform"));

    if(!this.platformProfile) {
      forkJoin([
        this.platformService.getPlatformprofile(this.loginIdService.getCurrentHeaders(), 'PLATFORM_CONNECT_BASE_VIEW'),
        this.platformService.getPlatformprofile(this.loginIdService.getCurrentHeaders(), 'PLATFORM_CONNECT_PROPERTIES_VIEW')
      ]).subscribe(async ([profile, propertiesProfile]) => {
        profile.properties = propertiesProfile.properties;
        sessionStorage.setItem("platform", JSON.stringify(profile));
        this.platformProfile = JSON.parse(sessionStorage.getItem("platform"));
        await this.checkPropertyAuthorities();
        this.refreshSums();
      });
    } else {
      await this.checkPropertyAuthorities();
      this.refreshSums();
    }

    // check the billing- and beneficiaryAddresses and assign them based on what is possible (property > user > platform)
    this.properties.forEach(p => {
      this.determineBillingInputs(p);
    });
    this.initComplete = true;
  }

  /**
   * Checks if there are authorities for the current properties in the indexed db.
   * If not the user will be redirected to the authority upload page.
   *
   * Currently this check only considers the platform type 'PROPERTY'.
   * If all properties have their origin in a saved property the check is skipped since saved properties already automatically have authorities attached
   */
  private async checkPropertyAuthorities(): Promise<void> {
    // Exit early if the platform type is not 'PROPERTY'
    if (this.platformProfile.platformType !== 'PROPERTY') {
      return;
    }

    // Exit early if all properties originate from a saved property since they automatically have authorities attached
    const allSavedProperties = this.properties.every(property => !!property.savedId);
    if (allSavedProperties) {
      return;
    }

    const storedAuthorities = await this.indexDBService.getAll('authorities').toPromise();
    // If at least one authority file is stored n the indexedDb no redirection is needed
    if(storedAuthorities.length > 0 || this.hasGeneralAuthority()) {
      return
    }

    // If the user hat not uploaded any authority files yet, redirect them to the authority page
    this.router.navigate(["/authority"]);
  }

  /**
   * Initializes all products from the category "Bauaktenarchivbesuche" by putting them into and extra array
   */
  public initBauakProducts(): void{
      this.bauakProducts = [];
      for(let product of this.productsByCategory["Bauaktenarchivbesuche"]) {
          this.bauakProducts.push(product);
      }
  }

  /**
   * Assigns a valid Billing- and BeneficiaryAddress to the Property
   * The order is Property > User > Platform
   * If no valid BillingAddress can be assigned to the property the BillingAddressModal is opened instead
   * and requires the user to enter a valid BillingAddress
   * @param property The Property to assign the BillingAddress to
   */
  determineBillingInputs(property: Property): void {
    // Try property billing address
    if (this.isPropertyBillingAddressComplete(property)) {
      const billingAddress = this.buildPropertyBillingAddress(property);
      property.billingAdress = billingAddress;

      // use same address if beneficiary is incomplete
      if (!this.isPropertyBeneficiaryAddressComplete(property)) {
        property.beneficiaryAddress = billingAddress;
      }
      return;
    }

    // Try current multi-user billing address
    if (this.isUserBillingAddressComplete(this.currentMultiUser)) {
      const billingAddress = this.buildPropertyBillingAddress(this.currentMultiUser);
      property.billingAdress = billingAddress;
      property.beneficiaryAddress = billingAddress;
      return;
    }

    // Try fallback to current user billing address
    if (this.isUserBillingAddressComplete(this.user)) {
      const billingAddress = this.buildPropertyBillingAddress(this.user);
      property.billingAdress = billingAddress;
      property.beneficiaryAddress = billingAddress;
      return;
    }

    // Try platform profile billing address
    if (this.isPlattformBillingAddressComplete(this.platformProfile)) {
      const billingAddress = this.buildPropertyBillingAddress(this.platformProfile);
      property.billingAdress = billingAddress;
      property.beneficiaryAddress = billingAddress;
      return;
    }

    // No valid source → open dialog
    console.error("No valid billing information available — opening Billing Address dialog");
    this.openDialog(property);
  }

  /**
   * Checks if the Properties BillingAddress is complete and returns true if its complete or false if not
   * @param property The Property to check
   */
  isPropertyBillingAddressComplete(property: Property): boolean {
    const { billingAdress } = property;
    return !!(billingAdress?.firma && billingAdress?.street && billingAdress?.plz && billingAdress?.town);
  }

  /**
   * Checks if the Properties BeneficiaryAddress is complete and returns true if its complete or false if not
   * @param property The Property to check
   */
  isPropertyBeneficiaryAddressComplete(property: Property): boolean {
    const { beneficiaryAddress } = property;
    return !!(beneficiaryAddress?.firma && beneficiaryAddress?.street && beneficiaryAddress?.plz && beneficiaryAddress?.town);
  }

  /**
   * Checks if the Users BillingAddress is complete and returns true if its complete or false if not
   * @param user The User to check
   */
  isUserBillingAddressComplete(user: User): boolean {
    const { billingAddress } = user;
    return !!(billingAddress?.recipient && billingAddress?.street && billingAddress?.zip && billingAddress?.town);
  }

  /**
   * Checks if the Platforms BillingAddress is complete and returns true if its complete or false if not
   * @param platform The Platform to check
   */
  isPlattformBillingAddressComplete(platform: PlatformProfile): boolean {
    const { company, billingInformation } = platform;
    return !!(company && billingInformation?.street && billingInformation?.zip && billingInformation?.town);
  }

  /**
   * Gets either a Property, User or PlatformProfile and builds a BillingAddress from that Object
   * The passed Objects attributes are checked for completion before beeing passed to this function
   * @param billingData The Object to build the BillingAddress from
   */
  buildPropertyBillingAddress(billingData: Property | User | PlatformProfile): BillingAdress {
    switch (true) {
      case 'billingAdress' in billingData:
        const property = billingData as Property;
        return {
          'name': null,
          'firma': property.billingAdress.firma,
          'street': property.billingAdress.street,
          'plz': property.billingAdress.plz,
          'town': property.billingAdress.town,
          'country': property.billingAdress.country
        };
      case 'billingAddress' in billingData:
        const user = billingData as User;
        return {
          'name': null,
          'firma': user.billingAddress.recipient,
          'street': user.billingAddress.street,
          'plz': user.billingAddress.zip,
          'town': user.billingAddress.town,
          'country': user.billingAddress.country
        };
      case 'billingInformation' in billingData:
        const profile = billingData as PlatformProfile;
        const { street, houseNumber, zip, town, country } = profile.billingInformation;
        return {
          'name': null,
          'firma': profile.company,
          'street': houseNumber ? `${street} ${houseNumber}` : street,
          'plz': zip,
          'town': town,
          'country': country
        };
    }
  }

  /**
   * Creates and returns an object where all documents are pre sorted into categories based on their method needed for price calculations.
   * This is done to avoid iterating the documents multiple times inside the html template
   * @param property Property for which the documents should be sorted into categories
   * @return Returns an Object containing packageGroups, regularPricingDocs and pricingOnRequestDocs, which are arrays of Documents, that represent the sorted documents of the property
   */
  public preProcessDocumentsForProperty(property: Property):{packageGroups: { package: PricingPackage, documents: Document[] }[], regularPricingDocs: Document[], pricingOnRequestDocs: Document[], premiumServiceDocs: Document[]}{
    const packageGroups: { package: PricingPackage, documents: Document[] }[] = [];
    const regularPricingDocs: Document[] = [];
    const premiumServiceDocs: Document[] = [];
    const pricingOnRequestDocs: Document[] = [];

    if(!property?.documents?.length){
      return {packageGroups, regularPricingDocs, pricingOnRequestDocs, premiumServiceDocs};
    }

    const {packageGroups: computedGroups, remainingDocuments} = this.findPropertyDocumentPackageGroups(property);
    computedGroups.forEach(group => packageGroups.push(group));

    for(const document of remainingDocuments){
      if(this.isDocumentPremiumService(document)){
        premiumServiceDocs.push(document);
      }
      else if(this.hasDocumentPricingOnRequest(document)){
        pricingOnRequestDocs.push(document);
      }
      else{
        regularPricingDocs.push(document);
      }
    }
    return {packageGroups, regularPricingDocs, pricingOnRequestDocs, premiumServiceDocs};
  }

  /**
   * Finds the best matching package groups for a property using a greedy coverage strategy.
   * Returns the selected package groups and the remaining (uncovered) documents.
   *
   * @param property Property for which the package groups should be found.
   * @return Returns an object containing packageGroups, which are arrays of PricingPackage objects, and remainingDocuments, which are arrays of Document objects.
   * packageGroups are sorted by categoryId, so that the packages with the highest categoryId are first.
   * remainingDocuments are the documents that were not covered by any package group.
   */
  private findPropertyDocumentPackageGroups(property: Property): {
    packageGroups: { package: PricingPackage, documents: Document[] }[],
    remainingDocuments: Document[]
  } {
    const packageGroups: { package: PricingPackage, documents: Document[] }[] = [];
    const remainingDocuments = new Set<Document>(property?.documents ?? []);
    const candidates = (this.pricing?.pricingPackages ?? [])
      .filter(pp => (pp.explicitDocuments?.length ?? 0) > 0);

    while(remainingDocuments.size > 0){
      let bestPackage: PricingPackage | null = null;
      let bestMatchedDocuments: Document[] = [];

      for(const pricingPackage of candidates){
        const matchedDocuments = (pricingPackage.explicitDocuments ?? [])
          .map(explicitDocument =>
            Array.from(remainingDocuments).find(document =>
              document.docname === explicitDocument.documentName &&
              PackageSelectionUtils.isExplicitDocumentSelectionMatch(document, explicitDocument)
            ) ?? null
          )
          .filter((document): document is Document => !!document);

        // A package is only a valid candidate if all explicit documents are matched.
        if (matchedDocuments.length !== (pricingPackage.explicitDocuments?.length ?? 0)) {
          continue;
        }

        if(matchedDocuments.length > bestMatchedDocuments.length){
          bestMatchedDocuments = matchedDocuments;
          bestPackage = pricingPackage;
        }
      }

      if(!bestPackage || bestMatchedDocuments.length === 0){
        break;
      }

      packageGroups.push({package: bestPackage, documents: bestMatchedDocuments});
      bestMatchedDocuments.forEach(doc => remainingDocuments.delete(doc));
      const bestIndex = candidates.indexOf(bestPackage);
      if(bestIndex >= 0){
        candidates.splice(bestIndex, 1);
      }
    }

    packageGroups.sort((a, b) => {
      const aCat = a.package.categoryId ?? Number.MAX_SAFE_INTEGER;
      const bCat = b.package.categoryId ?? Number.MAX_SAFE_INTEGER;
      return aCat - bCat;
    });

    return {packageGroups, remainingDocuments: Array.from(remainingDocuments)};
  }

  /**
   * Categorizes all documents for a property based on their needed price calculations
   */
  public categorizeProperties(){
    for(const property of this.properties) {
      this.categorizedDocumentsList[property.id] = this.preProcessDocumentsForProperty(property);
      this.getDocumentsGroupedByCategory(property.id);
    }
  }

  getFullName(shortName) {
    return this.documentService.getFullName(shortName, this.products);
  }

  /**
   * Retrieves the title for a given pricing package group based on the platform type.
   *
   * @param {PricingPackage} pricingPackage - The pricing package object containing details such as the package name.
   * @return {string} The formatted title for the package group.
   */
  getPackageTitleForGroup(pricingPackage: PricingPackage): string {
    const baseTitle = this.platformProfile?.platformType === "STEUER" ? "Steuerpaket" : "Paket";
    const name = pricingPackage?.packageName;
    return name ? `${baseTitle}: ${name}` : baseTitle;
  }

  /**
   * Retrieves the pricing of a specific package for a given property.
   *
   * @param {Property} property - The property for which the package price is being retrieved.
   * @param {PricingPackage} pricingPackage - The pricing package whose price needs to be calculated.
   * @return {number | undefined} The price of the package for the specified property, or undefined if not found.
   */
  getPackagePriceForProperty(property: Property, pricingPackage: PricingPackage): number | undefined {
    if(this.paymentDetailsExplicitDocumentPackages?.order_lines){
      const orderLine = this.getExplicitPackageOrderLinesForProperty(property)
        .find(line => line?.reference === (pricingPackage?.packageName ?? "Paket"));
      if (orderLine) {
        return orderLine.total_amount / 100;
      }
    }
  }

  /**
   * Retrieves explicit package order lines associated with a specific property.
   *
   * @param {Property} property - The property for which to retrieve package order lines.
   * @return {any[]} A list of order lines related to the given property.
   */
  private getExplicitPackageOrderLinesForProperty(property: Property): any[] {
    if(!this.paymentDetailsExplicitDocumentPackages?.order_lines){
      return [];
    }
    const propertyIndex = this.properties.indexOf(property) + 1;
    return this.paymentDetailsExplicitDocumentPackages.order_lines
      .filter(orderLine => (orderLine?.name || '').includes(`Objekt ${propertyIndex}`));
  }
  /**
   * Checks if a specific document is a document premium service (bauakte, digitization or leitung)
   *
   * @param document Document that should be checked
   * @return true if the document is a document premium service else false
   */
  public isDocumentPremiumService(document: Document): boolean {
    return this.bauakProducts?.some(product => document.docname === product.nameShort) ||
      this.productsByCategory?.["Digitalisierungsservice"].some(product => document.docname === product.nameShort) ||
      this.productsByCategory?.["Leitungsauskünfte"].some(product => document.docname == product.nameShort) ||
      this.productsByCategory?.["Grundakte"].some(product => document.docname == product.nameShort)
  }

  hasDocumentPricingOnRequest(document: Document) {
    let pricingOnRequest = false;
    this.products.forEach(p => {
      if(p.nameShort === document.docname && p.pricingOnRequest){
        pricingOnRequest = true;
      }
    })

    return pricingOnRequest;
  }

  checkBillingInformationBeforeSubmitOrder(): boolean {
    let proceed = false;
      for(let prop of this.properties) {
        if(!this.isPropertyBillingAddressComplete(prop)) {
          this.openDialog(prop);
          return false;
        } else {
          proceed = true;
        }
      }
    return proceed;
  }

  checkNotificationSettings(): boolean {
    const check = this.currentMultiUser && this.currentMultiUser.mail && this.contactList.length > 0;
    if (!check) {
      this.errorMsg = "Bitte hinterlegen Sie mindestens eine gültige E-Mail-Adresse!"
    }
    return check;
  }

  async setOrder(): Promise<void> {
    if(this.additionalOrderInformationForm.valid) {

      // check if all Properties have valid and complete BillingInformation => if not display BillingInformationModal and stop
      if (!this.checkBillingInformationBeforeSubmitOrder()) {
        return;
      }

      if (!this.checkNotificationSettings()) {
        return;
      }

      this.startedOrderProcess = true;
      await this.createOrder();

    } else {
      FormUtils.markInvalidInputs(this.additionalOrderInformationForm);
    }
  }

  async createOrder(): Promise<void> {
    let platformProfile = JSON.parse(sessionStorage.getItem("platform"));
    let order: Order = new Order();
    order.properties = this.properties;

    const notificationSettings = new NotificationSettings();
    notificationSettings.recipients = this.contactList.join();
    notificationSettings.frequency = NotificationSettings.Frequency.INSTANT;

    order.notificationSettings = notificationSettings;
    order.name = this.additionalOrderInformationForm.controls["customOrderName"].value;
    order.info = this.additionalOrderInformationForm.controls["additionalInformation"].value;
    order.positionBodies = this.buildBillingPositions();
    order.origin = StaticData.ORIGIN_CONNECT;
    let cart:Cart = new Cart();
    cart.order = order;
    cart.platformProfile = platformProfile;
    (await this.orderService.setMultiUserOrder(cart)).subscribe(async next => {
      sessionStorage.removeItem("new_order_properties");
      sessionStorage.removeItem("mandate_id");
      sessionStorage.removeItem("legitimate_interest");
      sessionStorage.removeItem("authorityData");
      sessionStorage.removeItem("subAuthorityData");
      sessionStorage.removeItem("logo");
      sessionStorage.removeItem("savedPropertyDocuments")
      sessionStorage.removeItem("new_order_owner_research_properties")
      localStorage.removeItem("authorityData");
      localStorage.removeItem("subauthorityData")
      localStorage.removeItem("vollmacht");
      this.authorityService.setLastPropertyHash(null)
      await this.indexDBService.clear('authorities').toPromise() ;
      this.router.navigateByUrl('/confirmation', {state: {orderId: next, orderState: 1}}).then();
    }, error => {
      this.startedOrderProcess = false;
      this.showOrderError = true;
      console.log(error);
    });
  }

  getPriceForPropertyDocuments(property) {
    if(this.paymentDetailsProperties !== undefined){
      return this.paymentDetailsProperties.order_lines[this.properties.indexOf(property)].total_amount/100;
    }
  }

  /**
   * Determines whether any property contains at least one document that matches a bauak product.
   *
   * @return true if at least one property includes a bauak document, else false
   */
  public hasAnyPropertyBauakte(): boolean {
    return this.properties?.some(property =>
        property.documents?.some(document =>
            this.bauakProducts?.some(product => document.docname === product.nameShort)
        )
    ) ?? false;
  }

  /**
   * Checks whether any property contains a document of type 'bewilu'.
   *
   * @return true if at least one property includes a 'bewilu' document, else false
   */
  public hasAnyPropertyBewil(): boolean{
    return this.properties?.some(property =>
        property.documents?.some(document =>
            document.docname === "bewilu"
        )
    ) ?? false;
  }

  /**
   * Retrieves the data research price of a property.
   *
   * @param property property whose research price is looked up
   * @return the research price, or undefined while the summary has not been loaded yet
   */
  getPriceForPropertyDataResearch(property){
    if(this.paymentDetailsDataResearch === undefined){
      return;
    }
    // the bucket holds one line per researched property, so only those may be counted to find the right one
    const researchedIndex = this.properties.filter(p => p.dataResearch).indexOf(property);
    const orderLine = this.paymentDetailsDataResearch.order_lines[researchedIndex];
    return orderLine ? orderLine.total_amount / 100 : 0;
  }

  removeDocumentFromProperty(property,document){
    // Prevent the removal of a 'grunde' document if a 'bauak' or 'bewilu' document is still in the cart
    const bauakDocument = ProductUtils.getBauakDocument(property.documents);
    const bewilDocument = property.documents.find(d => d.docname === "bewilu");
    if(document.docname === "grunde" && (bauakDocument || bewilDocument)){
      const blockingDocument = bauakDocument || bewilDocument;
      this.snackbarService.showSnackbarByType(
          `Der Grundbuchauszug ist zur Qualitätssicherung obligatorisch und kann nicht entfernt werden, da das Produkt 
          ${NameFinderUtils.getProductLongName(blockingDocument.docname,this.products, null)} ausgewählt ist. Bitte entfernen Sie dieses zunächst aus dem Warenkorb.`,
          "warning", 5000);
      return;
    }

    property.documents.forEach((d,index) =>{
      if(d === document){
        property.documents.splice(index,1);
        this.removeCategorizedDocument(property.id, document);
        this.removeProductValueFromSelectedProperty(document.docname, property)
      }
    });
    if (property.documents.length > 0) {
      this.categorizedDocumentsList[property.id] = this.preProcessDocumentsForProperty(property);
    }
    if(property.documents.length < 1){
      this.removePropertyFromCart(property);
    }
    this.refreshSums();
    sessionStorage.setItem("new_order_properties",JSON.stringify(this.properties));
  }

  async removePropertyFromCart(property){

    this.properties.forEach((p,index) =>{
      if(p === property){
        this.properties.splice(index,1);
        delete this.categorizedDocumentsList[property.id];
      }
    });

    let propertyStorrage: string;
    let url: string;
    this.route.queryParams.subscribe(params => {
      if (params['owner-research'] === 'true') {
        propertyStorrage = 'new_order_owner_research_properties';
        url = "/owner-research";
      } else {
        propertyStorrage = 'new_order_properties';
        url = "/new_order";
      }
    });
    sessionStorage.setItem(propertyStorrage,JSON.stringify(this.properties));

    await this.authorityService.removeAuthoritiesFromIndexedDbByProperty(property);

    if(this.properties.length < 1){
      this.router.navigateByUrl(url).then();
    }
    else{
      this.refreshSums();
    }
  }

  /**
   * Removes a specific document, specified by the docname, from the categorized property documents
   *
   * @param propertyId Id of the property for which the document should be removed
   * @param document document which should be removed from the categorized property documents
   */
  private removeCategorizedDocument(propertyId: number, document: Document): void {
    const categorizedPropertyDocuments = this.categorizedDocumentsList[propertyId];

    categorizedPropertyDocuments.packageGroups = categorizedPropertyDocuments.packageGroups
      .map(group => ({...group, documents: group.documents.filter(doc => doc.docname !== document.docname)}))
      .filter(group => group.documents.length > 0);
    categorizedPropertyDocuments.regularPricingDocs = categorizedPropertyDocuments.regularPricingDocs.filter(doc => doc.docname !== document.docname)
    categorizedPropertyDocuments.pricingOnRequestDocs = categorizedPropertyDocuments.pricingOnRequestDocs.filter(doc => doc.docname !== document.docname)
    categorizedPropertyDocuments.premiumServiceDocs = categorizedPropertyDocuments.premiumServiceDocs.filter(doc => doc.docname !== document.docname)
  }

  /**
   * Removes product values associated with a specific document from the given property
   *
   * @param documentShortName Short name of the document for which associated product values should be removed from the property
   * @param property Property from which product values need to be removed.
   */
  private removeProductValueFromSelectedProperty(documentShortName: string, property: Property): void{
    // Products whose values have to be removed from the selected property
    const relevantProducts = this.products.filter(product => product.nameShort === documentShortName);

    relevantProducts.forEach(product => {
      product.productValues?.forEach(productValue => {
        if (productValue?.key && property.additionalProductValues) {
          delete property.additionalProductValues[productValue.key];
        }
      });
    });
  }

  /**
   * Refreshes and recalculates all payment-related sums for the current order.
   * Fetches payment summary data from the backend and updates property and research totals accordingly.
   */
  refreshSums(){
    this.propertySum = 0;

    this.orderService.getPaymentSummary(this.properties).subscribe(summary => {
      this.pricingUnavailable = false;

      // Assign retrieved payment breakdowns
      this.paymentDetailsExplicitDocumentPackages = summary.explicit_document_packages;
      this.paymentDetailsProperties = summary.documents_without_data_research;
      this.paymentDetailsDataResearch = summary.data_research;
      this.premiumServiceDocumentOrderLines = summary.premium_services?.order_lines || [];
      // cancellations are already part of the documents bucket, so they must not be added to the sum again
      this.groupCancellationsByProperty(summary.cancellations?.order_lines || []);

      // Retrieve all document related order lines
      const documentOrderLines = summary.documents?.order_lines || [];

      // Calculate total property sum including premium services
      this.propertySum += this.sumOrderLineAmounts(documentOrderLines);
      this.propertySum += this.sumOrderLineAmounts(this.premiumServiceDocumentOrderLines);

      // Calculate sums excluding and including data research
      this.propertySumWithoutDataSearch = this.sumOrderLineAmounts(this.paymentDetailsProperties?.order_lines);
      this.propertySumDataSearch = this.sumOrderLineAmounts(this.paymentDetailsDataResearch?.order_lines);

      this.categorizeProperties();
    }, () => {
      // Without prices from the pricing engine the summary must not show a total the order is not placed with
      this.pricingUnavailable = true;
    });
  }

  /**
   * Calculates the total amount for a list of order lines
   *
   * @param orderLines Array of order line items containing the price data.
   * @return total calculated amount
   */
  private sumOrderLineAmounts(orderLines: any[] = []): number {
    if (!orderLines) {
      return 0;
    }
    // total_amount already is unit_price times quantity, multiplying by the quantity again would double count it
    return orderLines.reduce((sum, current) => sum + (current.total_amount || 0) / 100, 0);
  }

  openDialog(property) {
    const dialogRef = this.dialog.open(BillingAddressDialogComponent, {
      width: '600px',
      data: {property: property}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        property.billingAdress = result.billingAddress;
        property.beneficiaryAddress = result.beneficiaryAddress;
      }
    });
  }

  billingAdressEqualsBeneficiaryAdress(property) {
    const { billingAdress, beneficiaryAddress } = property;
    return (
            billingAdress && beneficiaryAddress &&
        billingAdress.firma === beneficiaryAddress.firma &&
        billingAdress.street === beneficiaryAddress.street &&
        billingAdress.plz === beneficiaryAddress.plz &&
        billingAdress.town === beneficiaryAddress.town
    );
  }

  addEmailToContactList(){
    if(this.contactListForm.valid && !this.contactList.includes(this.contactListForm.value.email)) {
      this.contactList.push(this.contactListForm.value.email)
      this.contactListForm.reset();
      this.errorMsg = "";
    } else {
      if (!this.contactListForm.valid) {
        this.errorMsg = "Bitte geben Sie eine gültige E-Mail ein."
      } else {
        this.errorMsg = "Die angegebene E-Mail Adresse ist bereits hinterlegt.";
      }
    }
  }

  hasGeneralAuthority(){
    let platformProfile = JSON.parse(sessionStorage.getItem("platform"));
    if(platformProfile !== null){
      let generalAuthorities = platformProfile.authorities;
      return generalAuthorities != null && generalAuthorities.length > 0;
    }
  }

  /**
   * Gets the price for a document premium service based on the corresponding order line containing the price information.
   * The correct oder line is found by the propertyId and the document name
   *
   * @param propertyId id of a property potentially containing a document premium service
   * @param docname name of the document premium service that should be checked
   * @return price of the document premium service or 0 if no orderline for the property and docname could be found
   */
  public getPremiumServiceDocumentPrice(propertyId: string, docname: string): number {
      const foundOrderLine = this.premiumServiceDocumentOrderLines.find(orderLine => orderLine.reference === propertyId + " - " + docname)
      if (foundOrderLine) {
          return foundOrderLine.total_amount / 100
      } else {
          return 0
      }
  }

  /**
   * Groups the cancellation order lines by property, one entry per credited document. The order lines are referenced
   * by the propertyId and the document name, like the premium service order lines.
   *
   * @param cancellationOrderLines Order lines of the cancellation bucket
   */
  private groupCancellationsByProperty(cancellationOrderLines: any[]): void {
    this.cancellationsByProperty = {};
    for (const property of this.properties) {
      const prefix = property.id + " - ";
      this.cancellationsByProperty[property.id] = cancellationOrderLines
        .filter(orderLine => orderLine.reference?.startsWith(prefix))
        .map(orderLine => {
          const docname = orderLine.reference.substring(prefix.length);
          return {docname, label: docname ? this.getFullName(docname) : "Storno", amount: orderLine.total_amount / 100};
        });
    }
  }

  /**
   * Gets the cancellations of a property, one per credited document.
   *
   * @param property Property whose cancellations should be retrieved
   * @return credited documents of the property with their label, document name and (negative) amount
   */
  public getCancellationsForProperty(property: Property): Cancellation[] {
    return this.cancellationsByProperty[property.id] ?? [];
  }

  /**
   * Sums the cancellations of a property.
   *
   * @param property Property whose cancellations should be summed
   * @return the (negative) sum of all cancellations of the property
   */
  public getCancellationSumForProperty(property: Property): number {
    return this.getCancellationsForProperty(property).reduce((sum, cancellation) => sum + cancellation.amount, 0);
  }

  /**
   * Checks if the Baulast of a property is cancelled, which happens if it cannot be delivered in its state.
   *
   * @param property Property that should be checked
   * @return true if a Baulast of the property is cancelled else false
   */
  public hasBaulasCancellation(property: Property): boolean {
    return this.getCancellationsForProperty(property).some(cancellation => cancellation.docname === "baulas");
  }

  /**
   * Checks if a specific docname is a bauakten document docname
   *
   * @param docname name that should be checked
   * @return true if the docname is a bauakten docname else false
   */
  public isDocumentBauaktenDocument(docname: string): boolean {
      return this.bauakProducts.some(product => docname === product.nameShort)
  }

  /**
   * Checks if a specific docname is grunde (Grundbuchauszug) document docname
   *
   * @param docName Name of the document that should be checked
   * @return true if the docname is a grunde docname else false
   */
  public isDocumentGrundeDocument(docName: string): boolean{
    return docName === 'grunde' || docName === "grundb"
  }

  /**
   * Generates and sets a default name for the customOrderName
   *
   * If the order contains only one property the naming scheme is {town} - {street} of the property
   * If the order contains more than one property the naming scheme is {town1}, {town2}, {town3}, +++
   */
  public setCustomOrderName(): void {
    let customOrderName = "";

    if (this.properties.length == 1) {
      customOrderName = this.properties[0].name ? `${this.properties[0].name} (${this.properties[0].town}-${this.properties[0].street})` : this.properties[0].town + ' - ' + this.properties[0].street;
    } else {
      const uniquePropertyTownNames = [... new Set(this.properties.map(property => property.town))];
      customOrderName = uniquePropertyTownNames.slice(0, 3).join(', ');
      if(uniquePropertyTownNames.length > 3){
        customOrderName += ", +++";
      }
    }

    this.additionalOrderInformationForm.patchValue({
      customOrderName: customOrderName
    })
  }

  /**
   * Determines if a specific control of a form is valid after it was touched
   *
   * @param control AbstractControl that should be checked
   * @return true if the control is invalid and was touched else false
   */
  public hasError(control: AbstractControl): boolean {
      return (control.invalid && control.touched);
  }

    /**
     * Initializes the contact list form used for adding contacts that should get notified to an order
     */
  private initContactListForm(): void{
      this.contactListForm = this.formBuilder.group({
          email: new UntypedFormControl(null,Validators.email),
      });
  }

    /**
     * Initializes the additional order information form used for adding additional information to an order.
     * This form is specifically used to add a custom name and additional information to an order
     */
  private initAdditionalOrderInformationForm():void {
      this.additionalOrderInformationForm = this.formBuilder.group({
          customOrderName: new UntypedFormControl("", Validators.maxLength(this.maxReferenceInput)),
          additionalInformation: new UntypedFormControl("",Validators.maxLength(this.maxInformationInput))
      })
  }

  /**
   * Removes the passed Mail from the ContactList if it is within the list and if the list includes at least 2 entries
   * @param email  The mail to try to remove from the list
   */
  removeMailFromContactList(email: string) {
    this.errorMsg = "";
    if(this.contactList.includes(email) && this.contactList.length > 1) {
      this.contactList = this.contactList.filter(mail => mail !== email);
    } else {
      this.errorMsg = "Es muss mindestens eine E-Mail-Adresse hinterlegt sein!";
    }
  }

  /**
   * Add the currently logged in users mail address to the contactList if it is not already present
   */
  addCurrentUserMailToContactList(): void {
    const currentUser = JSON.parse(sessionStorage.getItem('user')) as User;
    if (currentUser && !this.contactList.includes(currentUser.mail)) {
      this.contactList.push(currentUser.mail);
    }
  }

  /**
   * Hides the delete button for the given address if it is the current users mail
   * @param email the mail to check
   */
  hideDeleteButtonForCurrentUserMail(email: string): boolean {
    return this.currentMultiUser.mail === email;
  }

  /**
   * Builds a list of billing position body objects for each property of this.properties
   *
   * @return Array of billing position body objects for each property
   */
  public buildBillingPositions(): BillingPositionBody[]{
    return this.properties.map(property => this.createBillingPosition(property));
  }

  /**
   * Creates a billing position body for the given property.
   *
   * @param property Property for which the billing position should be created
   * @return BillingPositionBody object populated with property information regarding pricing
   */
  private createBillingPosition(property: Property): BillingPositionBody{
    const positionBody = new BillingPositionBody();
    positionBody.tempPropertyId = property.id;
    const positionBodyHtml = this.buildPositionBodyText(property);
    // convert position body text to base 64 to prevent WAF errors
    positionBody.positionBodyText = btoa(String.fromCharCode(...new TextEncoder().encode(positionBodyHtml)));
    return positionBody;
  }

  /**
   * Builds a formatted HTML string representing the body text of a billing position for a property.
   *
   * @param property Property for which the position body text is built.
   * @return HTML string representing the formatted billing position body text for the property
   */
  private buildPositionBodyText(property: Property): string{
    let bodyText = '';

    bodyText += `<p ${StaticData.MAIL_TEMPLATE_STYLE}>${StaticData.MAIL_TEMPLATE_SPACER}</p><br>`;
    bodyText += this.addPackageSections(property);
    bodyText += this.addCategorySection(property, 'regularPricingDocs', 'Behördenauskünfte', this.getPriceForPropertyDocuments(property));
    bodyText += this.addPricingOnRequestSection(property);
    bodyText += this.addPremiumServiceSection(property);

    if (property.dataResearch) {
      bodyText += `<b ${StaticData.MAIL_TEMPLATE_STYLE}>Grundstückdatenrecherche - ${this.getPriceForPropertyDataResearch(property).toFixed(2)}€</b><br>`;
    }

    bodyText += this.addCancellationSection(property);
    bodyText += this.addFooterSection();

    return bodyText;
  }

  /**
   * Generates a formatted HTML section for a specific document category belonging to a property.
   * This is currently used for regular document sections and for package-specific document lists.
   *
   * The function resolves the list of documents either from the categorizedDocumentsList using
   * the provided `categoryKey`, or from an explicit override list via `docsOverride`. If the
   * resulting list contains documents, a styled section is constructed that includes:
   * - an optional spacer paragraph,
   * - a bold section title with an optional price,
   * - a UL-list containing formatted entries for each document.
   *
   * @param property The property for which the HTML section is generated.
   * @param categoryKey The key used to access the categorized documents for the property.
   * @param title The section title that appears above the document list.
   * @param price Optional price displayed next to the section title.
   * @param docsOverride Optional custom document list; if provided, this replaces the
   *                     category-based lookup for this section.
   * @param addSpacer Whether a spacer paragraph should be inserted before the section.
   * @return A formatted HTML string representing the document section.
   */
  private addCategorySection(property: Property, categoryKey: string | null, title: string, price?: number, docsOverride?: Document[], addSpacer: boolean = false): string{
    let section = '';
    const docs = docsOverride ?? (categoryKey ? this.categorizedDocumentsList[property.id][categoryKey] : []);

    if(docs && docs.length > 0){
      if (addSpacer) {
        section += `<p ${StaticData.MAIL_TEMPLATE_STYLE}>${StaticData.MAIL_TEMPLATE_SPACER}</p><br>`;
      }
      section += `<b ${StaticData.MAIL_TEMPLATE_STYLE}>${title}`;
      if (typeof price === 'number') {
        section += ` - ${price.toFixed(2)}€`;
      }
      section += `</b><br>`;
      section += `<ul ${StaticData.MAIL_TEMPLATE_STYLE}>`
      for(const document of docs){
        section = this.buildDocumentPositionString(section, document, property);
      }
      section += `</ul>`
    }
    return section;
  }

  /**
   * Adds package sections for the provided property by iterating through related package groups
   * and constructing section content based on the property and group information.
   *
   * @param {Property} property The property for which package sections are to be added.
   * @return {string} The constructed sections as a string.
   */
  private addPackageSections(property: Property): string{
    let section = '';
    const groups = this.categorizedDocumentsList[property.id]?.packageGroups ?? [];

    for(const group of groups){
      const title = this.getPackageTitleForGroup(group.package);
      const price = this.getPackagePriceForProperty(property, group.package);
      section += this.addCategorySection(property, null, title, price, group.documents);
    }

    return section;
  }

  /**
   * Generates a formatted HTML section for all documents that have a pricing only available on request for the given property
   *
   * @param property Property for which the formatted HTML section should be generated
   * @return HTML string representing the pricing on request section or an empty string if there is no pricing on request document
   */
  private addPricingOnRequestSection(property: Property): string{
    const docs = this.categorizedDocumentsList[property.id].pricingOnRequestDocs;
    return docs.length > 0 ? `<b>Preise auf Anfrage - Wir kontaktieren Sie.</b>` : '';
  }

  /**
   * Generates a formatted HTML section for premium service document for the given property
   *
   * @param property Property for which the premium service section should be generated
   * @return HTML string representing the premium service section or an empty string if there are no premium service documents
   */
  private addPremiumServiceSection(property: Property): string{
    const docs = this.categorizedDocumentsList[property.id].premiumServiceDocs;
    if (!docs.length || !this.premiumServiceDocumentOrderLines) return '';
    let section = '';
    const groupedDocs = this.premiumServiceDocumentGroups[property.id];
    for (const groupedDoc of groupedDocs) {
      const hasPricingOnRequest = groupedDoc.documents.some(document => this.hasDocumentPricingOnRequest(document));
      const groupPrice = hasPricingOnRequest ? undefined : groupedDoc.totalPrice;
      section += this.addCategorySection(property, 'premiumServiceDocs', groupedDoc.category, groupPrice, groupedDoc.documents, true);
    }
    return section;
  }

  /**
   * Generates a formatted HTML section for the cancelled documents of the given property
   *
   * @param property Property for which the cancellation section should be generated
   * @return HTML string representing the cancellation section or an empty string if nothing is cancelled
   */
  private addCancellationSection(property: Property): string {
    const cancellations = this.getCancellationsForProperty(property);
    if (!cancellations.length) return '';
    let section = `<p ${StaticData.MAIL_TEMPLATE_STYLE}>${StaticData.MAIL_TEMPLATE_SPACER}</p><br>`;
    section += `<b ${StaticData.MAIL_TEMPLATE_STYLE}>Storno - ${this.getCancellationSumForProperty(property).toFixed(2)}€</b><br>`;
    section += `<ul ${StaticData.MAIL_TEMPLATE_STYLE}>`;
    for (const cancellation of cancellations) {
      section += `<li ${StaticData.MAIL_TEMPLATE_STYLE}>${cancellation.label}</li>`;
    }
    section += `</ul>`;
    return section;
  }

  /**
   * Generates a formatted HTML section summarizing costs for the billing position body.
   *
   * @return HTML string representing the footer section of the billing position body.
   */
  private addFooterSection(): string {
    let footer = `<p ${StaticData.MAIL_TEMPLATE_STYLE}>${StaticData.MAIL_TEMPLATE_SPACER}</p><br><p ${StaticData.MAIL_TEMPLATE_STYLE}><b>Kostenübersicht:</b></p><br>`;

    footer += `<p ${StaticData.MAIL_TEMPLATE_STYLE_INDENT}><b>Zwischensumme: ${this.propertySum.toFixed(2)}€</b></p>`;

    footer += `<p ${StaticData.MAIL_TEMPLATE_STYLE_INDENT}><b><u>Gesamtsumme: ${this.propertySum.toFixed(2)}€</u></b></p><br>`;
    footer += `<p ${StaticData.MAIL_TEMPLATE_STYLE_INDENT}>zzgl. Behördenauslagen: 1:1</p>`;

    if (this.hasAnyPropertyBauakte()) {
      footer += `<p ${StaticData.MAIL_TEMPLATE_STYLE_INDENT}>zzgl. Behördenbesuch: ${this.bauakPricePerHour}€/h</p>`;
    }

    if(this.hasAnyPropertyBewil()){
      footer += `<p ${StaticData.MAIL_TEMPLATE_STYLE_INDENT}>zzgl. ${this.bewilCertificatePrice}€ pro Urkunde</p>`;
    }

    if (this.bookedAdditionalBauaktenServices) {
      for (const additionalServiceShortName of this.bookedAdditionalBauaktenServices) {
        footer += `<p ${StaticData.MAIL_TEMPLATE_STYLE_INDENT}>zzgl. ${this.getServiceLongName(this.bookableServicesByCategory, additionalServiceShortName)}: ${this.bauakPricePerHour}/h</p>`;
      }
    }

    return footer;
  }

  /**
   * Generates a formatted HTML section for a document.
   * Adds details specific to the document type including any special pricings or booked services
   *
   * @param positionBody Current HTML string representing the billing position body text.
   * @param document Document object for which the HTML section should be generated
   * @param property Property associated with the document
   * @return Updated HTML string including the generated document information section
   */
  private buildDocumentPositionString(positionBody: string, document: Document, property: Property): string {
    if(document.docname != 'digitiz' && document.docname != 'leitung'){
      positionBody += `<li ${StaticData.MAIL_TEMPLATE_STYLE}>${this.getFullName(document.docname)}</li>`;
    }

    if(this.isDocumentGrundeDocument(document.docname)){
      positionBody += `<ul ${StaticData.MAIL_TEMPLATE_STYLE}>`
      positionBody += `<li ${StaticData.MAIL_TEMPLATE_STYLE_INDENT}>50% des Dokumentenpreises für zusätzliche Grundbuchblätter</li>`
      positionBody += `</ul>`
    }

    if(property.isTeilunObtainableOnSite && document.docname === 'teilun'){
      positionBody += `<ul ${StaticData.MAIL_TEMPLATE_STYLE}>`
      positionBody += `<li ${StaticData.MAIL_TEMPLATE_STYLE_INDENT}>inkl. Vor-Ort Einsicht</li>`
      positionBody += `</ul>`
    }

    if(document.selectedServices.length > 0){
      positionBody += `<ul ${StaticData.MAIL_TEMPLATE_STYLE}>`
      for (let service of document.selectedServices) {
        positionBody += `<li>${this.getServiceLongName(this.bookableServicesByCategory, service.nameShort)}</li>`
      }
      positionBody += `</ul>`
    }

    if(document.docname === 'digitiz'){
      positionBody += `<p ${StaticData.MAIL_TEMPLATE_STYLE}>Sie erhalten von uns ein individuelles Angebot</p> <p ${StaticData.MAIL_TEMPLATE_STYLE}>Sie verursachen vorher noch keine Kosten.</p>`;
    }

    if(this.isDocumentBauaktenDocument(document.docname) && this.bauakPricePerHour > 0){
      positionBody += `<p ${StaticData.MAIL_TEMPLATE_STYLE}>Sofern ein Behördenbesuch erforderlich ist fallen zusätzlich Kosten in Höhe von ${this.bauakPricePerHour}€ pro Stunde an.</p>`
    }

    if(document.docname === 'bewilu'){
      positionBody += `<ul ${StaticData.MAIL_TEMPLATE_STYLE}>`
      positionBody += `<li ${StaticData.MAIL_TEMPLATE_STYLE_INDENT}>Es fallen zusätzliche Kosten in Höhe von ${this.bewilCertificatePrice}€ pro Urkunde an.</li>`
      positionBody += `</ul>`
    }

    return positionBody;
  }

  /**
   * Retrieves the relevant product for a given property, where product values are present in the 'additionalProductValues' of the property.
   *
   * @param property Property for which relevant product should be retrieved.
   * @return Array of product objects whose product values match keys in the 'additionalProductValues' of the property.
   *         If the property does not have additonalProductValues an empty array is returned.
   */
  public getRelevantProductValueProductsForProperty(property: Property): Product[]{
    if(!property.additionalProductValues){
      return [];
    }
    return this.products.filter(product =>
        product.productValues.some(productValue =>
            property.additionalProductValues.hasOwnProperty(productValue.key)
        )
    );
  }

  /**
   * Opens a dialog to allow the user to enter product values for a specific property.
   *
   * @param property Property for which the product value dialog should be opened.
   */
  public openProductValueDialogForProperty(property: Property){
    const dialogRef = this.dialog.open(ProductValueFormComponent, {
      width: '900px',
      panelClass: 'has-round-border',
      disableClose: true,
      data: {products: this.getRelevantProductValueProductsForProperty(property), useDialogFunctionality: true, selectedProperty: property}
    });

    dialogRef.afterClosed().subscribe(result => {
      // Save potentially updated properties in the session storage
      sessionStorage.setItem("new_order_properties",JSON.stringify(this.properties));
    })
  }

  /**
   * Filters product values to avoid showing duplicate ATP values.
   *
   * - Keeps only the first ATP key for each unique value.
   * - Non-ATP keys are always shown.
   *
   * @param product  The product whose values should be filtered.
   * @param property The property that holds ATP key-value mappings.
   * @returns Filtered list of ProductValue entries with unique ATP values.
   */
  public getFilteredProductValues(product: Product, property: Property): ProductValue[] {
    // Tracks which ATP values have already been processed
    const seenValues = new Set<string>();
    // Tracks ATP keys that should be retained (only one per distinct value)
    const allowedAtpKeys = new Set<string>();

    // Step 1: Loop through all known ATP keys to find unique values
    for (const key of StaticData.ATP_KEYS) {
      const value = property.additionalProductValues[key];
      // Skip undefined, null, or empty values
      if (!value){
        continue;
      }
      // If this value hasn't been seen yet, allow this key
      if (!seenValues.has(value)) {
        seenValues.add(value);
        allowedAtpKeys.add(key);
      }
    }

    // Step 2: Filter the product's values
    return product.productValues.filter(pv => {
      const key = pv.key;

      // Always include values that are not ATP-related
      if (!StaticData.ATP_KEYS.includes(key)) {
        return true;
      }

      // For ATP keys, include only those selected in Step 1
      return allowedAtpKeys.has(key);
    });
  }

  /**
   * Groups all premium-service documents belonging to a specific property by their product category
   * and calculates the total price per category.
   *
   * The function retrieves the premium-service documents for the given property, determines each
   * document’s category using its short name, and aggregates them into a grouped structure. While
   * grouping, it also accumulates the price for each category based on the document’s premium service
   * pricing.
   *
   * @param propertyId The ID of the property whose premium-service documents should be grouped.
   */
  public getDocumentsGroupedByCategory(propertyId: string): void {
    const docs: Document[] = this.categorizedDocumentsList[propertyId]?.premiumServiceDocs ?? [];

    // Group documents by category
    const grouped = docs.reduce((acc, doc) => {
      const category = this.findProductCategoryByShortName(doc.docname, this.productsByCategory);
      if (!acc[category]) {
        acc[category] = { documents: [], totalPrice: 0 };
      }

      acc[category].documents.push(doc);

      // Accumulate category price
      const price = this.getPremiumServiceDocumentPrice(propertyId, doc.docname) || 0;
      acc[category].totalPrice += price;

      return acc;
    }, {} as Record<string, { documents: any[]; totalPrice: number }>);

    // Transform into a list suitable for *ngFor
    this.premiumServiceDocumentGroups[propertyId] = Object.entries(grouped).map(([category, { documents, totalPrice }]) => ({
      category,
      documents,
      totalPrice,
    }));
  }
}

interface DocumentCategoryGroup {
  category: string;
  documents: Document[];
  totalPrice: number;
}

interface Cancellation {
  docname: string;
  label: string;
  amount: number;
}
